/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { css } from '@emotion/react'
import { connect } from 'react-redux'
import { bool } from 'prop-types'

import InstallIcon from 'gatsby-theme-marketplace-base/src/assets/icons/LC-install.inline.svg'
import { PRODUCT } from 'gatsby-theme-marketplace-base/src/utils'
import {
  getDesignationLabel,
  getProductIFrameUrl,
} from 'gatsby-theme-marketplace-base/src/utils/products'
import { isAuthorized } from 'gatsby-theme-marketplace-base/src/store/selectors'
import Collapse from 'gatsby-theme-marketplace-base/src/components/Collapse'
import useHydrationContext from 'gatsby-theme-marketplace-base/src/hooks/useHydrationContext'

const collapseMenuCss = ({ colors, font }) => css`
  > .collapse__input:checked + label.collapse__label-wrapper .collapse__label {
    span {
      color: ${colors.blueRibbon};
      font-weight: ${font.bold};
    }

    svg {
      fill: ${colors.blueRibbon};
    }
  }

  .collapse__label {
    padding: 0 26px;
    align-items: center;
    justify-content: space-between;

    svg {
      max-width: 20px;
      max-height: 20px;
      margin-right: 10px;
    }

    > div.sidebar-item {
      display: flex;
      width: 100%;
      font-size: 16px;
      text-transform: none;
      margin-left: 0;
      margin-bottom: 5px;

      > svg {
        margin-top: 2px;
        margin-right: 11px;
      }
    }

    .collapse__icon {
      margin-top: 5px;
    }
  }

  .collapse__content {
    padding: 0 26px;
    align-items: center;

    > div {
      margin-top: 5px;
      margin-left: 32px;

      a {
        margin: 4px 0;
      }

      &:last-of-type > a {
        margin-bottom: 14px;
      }
    }
  }
`

const productPathsList = [
  {
    product: PRODUCT.LiveChat,
    path: '/settings/marketplace/installed',
  },
  {
    product: PRODUCT.HelpDesk,
    path: '/settings/integrations/installed',
  },
]

const AppSectionLinks = ({ isAuthorized }) => {
  const hydrated = useHydrationContext()
  if (!hydrated || !isAuthorized) {
    return null
  }

  return (
    <ul className="list">
      <Collapse
        isOpenOnInit={false}
        css={collapseMenuCss}
        storageKey="installed-apps"
        noLabelNav
        label={
          <div className="sidebar-item">
            <InstallIcon />
            <span>Installed Apps</span>
          </div>
        }
        content={productPathsList.map(({ product, path }) => {
          const productLabel = getDesignationLabel(product)
          const href = `${getProductIFrameUrl(product)}${path}`

          return (
            <div key={`${product}-installed-apps`}>
              <a
                href={href}
                title={`Installed ${productLabel} apps`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Manage apps for {productLabel}</span>
              </a>
            </div>
          )
        })}
      />
    </ul>
  )
}

const mapStateToProps = (state) => ({
  isAuthorized: isAuthorized(state),
})

AppSectionLinks.propTypes = {
  isAuthorized: bool,
}

export default connect(mapStateToProps)(AppSectionLinks)
